// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import store from './store'
import 'lib-flexible'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Storage from 'vue-ls'

import 'swiper/dist/css/swiper.css';
import Constant from './components/Constant'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';  // or 'ant-design-vue/dist/antd.less'



import { Button,Modal} from 'ant-design-vue';
import * as echarts from 'echarts'


import App from './App'
import router from './router'


Vue.prototype.$echarts = echarts
Vue.use(Button);
Vue.use(Modal);

Vue.config.productionTip = false;

Vue.use(VueAwesomeSwiper /* { default options with global component } */)

// eslint-disable-next-line no-unused-expressions
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.prototype.constant = Constant
Vue.prototype.moment = moment
Vue.use(Storage)
Vue.use(Antd);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js